import React from 'react';
import './SAdminSettingsTab.scss';
import { withTranslation } from 'react-i18next';
import { Tabs, Tab } from 'react-bootstrap';
import RiskConfiguration from '../../Common/RiskSettings/RiskConfiguration/RiskConfiguration';


const SAdminSettingsTab = ({ t }) => {
  return (
    <>
      {/* <Tabs
        defaultActiveKey="Risk-score-weight-tab"
        id="fill-tab-example"
        className="All_tab-viewbox"
      >
        <Tab eventKey="Risk-score-weight-tab" title="">
          <RiskConfiguration/>
        </Tab>
      </Tabs> */}
       <RiskConfiguration/>

    </>
  );
};
export default withTranslation()(SAdminSettingsTab);